// extracted by mini-css-extract-plugin
export default {"product-list-item":"product-list-item_ZbqcwMgO","product-list-item__anchor":"product-list-item__anchor_JxuGgifL","product-list-item_name":"product-list-item_name_whFrKvyn"};